import { render, staticRenderFns } from "./ViewArticle.vue?vue&type=template&id=a1899986&scoped=true&"
import script from "./ViewArticle.vue?vue&type=script&lang=js&"
export * from "./ViewArticle.vue?vue&type=script&lang=js&"
import style0 from "./ViewArticle.vue?vue&type=style&index=0&id=a1899986&prod&lang=scss&scoped=true&"
import style1 from "./ViewArticle.vue?vue&type=style&index=1&id=a1899986&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1899986",
  null
  
)

export default component.exports